module.exports = __webpack_public_path__ + "static/media/beginner.f4161860.svg";